<ion-header class="form-header">
  <ion-toolbar class="modal-toolbar">
    <ion-title class="modal-title">{{ modalTitle || ('NEW_BRANCH' | translate) }}</ion-title>
    <ion-buttons slot="end">
      
      <ion-button class="ion-text-capitalize btn-design" (click)="onSaveClick()">
        {{ form?.get('id')?.value ? 'Update' : ('SAVE' | translate) }}
      </ion-button>

      <ion-button class="ion-text-capitalize btn-design" (click)="onCloseClick()">
        {{ 'CLOSE' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form" class="smartdine-form">
    <ion-list>
      <!-- Branch Name -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'BRANCH_NAME' | translate }}<span class="text-danger">*</span></ion-label>
        <ion-input slot="end" formControlName="name" placeholder="Enter branch name"></ion-input>
       
      </ion-item>
      <ion-text color="danger" *ngIf="form.get('name')?.invalid && form.get('name')?.touched">
        <p class="ion-padding-start">Branch name is required.</p>
      </ion-text>

      <!-- Description -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'DESCRIPTION' | translate }}</ion-label>
        <ion-input slot="end" formControlName="description" placeholder="Enter description"></ion-input>
      </ion-item>

      <!-- Branch Code -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'BRANCH_CODE' | translate }}<span class="text-danger">*</span></ion-label>
        <ion-input slot="end" formControlName="restaurantBranchCode" placeholder="Branch code"></ion-input>
        
      </ion-item>
      <ion-text color="danger" *ngIf="form.get('restaurantBranchCode')?.invalid && form.get('restaurantBranchCode')?.touched">
        <p class="ion-padding-start">Branch code is required.</p>
      </ion-text>

      <!-- Address -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'ADDRESS' | translate }}</ion-label>
        <ion-input slot="end" formControlName="address" placeholder="Enter address"></ion-input>
      </ion-item>

      <!-- City -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'CITY' | translate }}</ion-label>
        <ion-input slot="end" formControlName="city" placeholder="Enter city"></ion-input>
      </ion-item>

      <!-- State -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'STATE' | translate }}</ion-label>
        <ion-input slot="end" formControlName="state" placeholder="Enter state"></ion-input>
      </ion-item>

      <!-- Country -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'COUNTRY' | translate }}</ion-label>
        <ion-input slot="end" formControlName="country" placeholder="Enter country"></ion-input>
      </ion-item>

      <!-- Country Code -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'COUNTRY_CODE' | translate }}</ion-label>
        <ion-input slot="end" formControlName="countryCode" placeholder="Country code (e.g. +91)"></ion-input>
      </ion-item>

      <!-- Pin Code -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'PIN_CODE' | translate }}</ion-label>
        <ion-input slot="end" formControlName="pincode" placeholder="Enter pin code"></ion-input>
      </ion-item>

      <!-- Email ID -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'EMAIL_ID' | translate }}</ion-label>
        <ion-input slot="end" type="email" formControlName="emailId" placeholder="Enter email address"></ion-input>
      </ion-item>
      <ion-text color="danger" *ngIf="form.get('emailId')?.invalid && form.get('emailId')?.touched">
        <p class="ion-padding-start">Enter a valid email.</p>
      </ion-text>

      <!-- Website -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'WEBSITE_NAME' | translate }}</ion-label>
        <ion-input slot="end" type="url" formControlName="website" placeholder="Website URL"></ion-input>
      </ion-item>

      <!-- Contact Number -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'CONTACT_NO' | translate }}</ion-label>
        <ion-input slot="end" type="tel" formControlName="contactNumber" placeholder="Enter contact number"></ion-input>
      </ion-item>
      <ion-text color="danger" *ngIf="form.get('contactNumber')?.invalid && form.get('contactNumber')?.touched">
        <p class="ion-padding-start">Enter a valid phone number.</p>
      </ion-text>

      <!-- GST IN -->
      <ion-item lines="inset">
        <ion-label slot="start">{{ 'GST_IN' | translate }}</ion-label>
        <ion-input slot="end" formControlName="gstIN" placeholder="Enter GST number"></ion-input>
      </ion-item>
    </ion-list>
  </form>
</ion-content>
